export default (selector, options) => {
  options = Object.assign({
    animationDirection: 'right',
    animationSpeed: 16
  }, options);
  const offsetFactor = options.animationDirection !== 'left' ? -1 : 0;
  const view = document.querySelector(selector);
  if (!view) {
    return;
  }
  const childNodesLength = view.childNodes.length;
  for (let i = 0; i < childNodesLength; i++) {
    view.appendChild(view.childNodes[i].cloneNode(true));
  }
  let rem = getComputedStyle(document.body).fontSize;
  rem = rem.substring(0, rem.length - 2);
  rem = Number.parseFloat(rem);
  let width = 0;
  const onResize = () => {
    width = view.scrollWidth / 2;
  };
  window.addEventListener('resize', onResize);
  onResize();
  let offset = 0;
  const update = () => {
    offset += (offsetFactor ? options.animationSpeed : -options.animationSpeed) / rem;
    const localOffset = offset % width + offsetFactor * width;
    view.style.transform = 'translateX(' + localOffset.toFixed(3) + 'px)';
    requestAnimationFrame(update);
  };
  update();
};